module.exports = __webpack_public_path__ + "static/media/jep.static.355edd78.svg";